var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPioneersPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 398.23 468.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-82);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-14);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-8);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-10);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-84);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-59);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-18);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-42);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-31);\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-13);\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-28);\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-58);\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100);\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-89);\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-46);\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-24);\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-23);\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-61);\r\n      }\r\n\r\n      .cls-20 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-56);\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-24);\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-44);\r\n      }\r\n\r\n      .cls-23 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-69);\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-5);\r\n      }\r\n\r\n      .cls-25 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442);\r\n      }\r\n\r\n      .cls-26 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-15);\r\n      }\r\n\r\n      .cls-27 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-14);\r\n      }\r\n\r\n      .cls-28 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-16);\r\n      }\r\n\r\n      .cls-29 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-3);\r\n      }\r\n\r\n      .cls-30 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-20);\r\n      }\r\n\r\n      .cls-31 {\r\n        stroke-width: 6px;\r\n      }\r\n\r\n      .cls-31, .cls-32, .cls-33 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-31, .cls-33, .cls-34 {\r\n        stroke: #e2be63;\r\n      }\r\n\r\n      .cls-35 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-88);\r\n      }\r\n\r\n      .cls-36 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-16);\r\n      }\r\n\r\n      .cls-37 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-21);\r\n      }\r\n\r\n      .cls-38 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-27);\r\n      }\r\n\r\n      .cls-39 {\r\n        opacity: .49;\r\n      }\r\n\r\n      .cls-40 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-26);\r\n      }\r\n\r\n      .cls-41 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-3);\r\n      }\r\n\r\n      .cls-42 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-11);\r\n      }\r\n\r\n      .cls-43 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-20);\r\n      }\r\n\r\n      .cls-44 {\r\n        fill: #bfa153;\r\n      }\r\n\r\n      .cls-45 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-5);\r\n      }\r\n\r\n      .cls-46 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-19);\r\n      }\r\n\r\n      .cls-47 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-70);\r\n      }\r\n\r\n      .cls-48 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-22);\r\n      }\r\n\r\n      .cls-49 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-25);\r\n      }\r\n\r\n      .cls-50 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-7);\r\n      }\r\n\r\n      .cls-51 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-67);\r\n      }\r\n\r\n      .cls-52 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-45);\r\n      }\r\n\r\n      .cls-53 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-76);\r\n      }\r\n\r\n      .cls-54 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-4);\r\n      }\r\n\r\n      .cls-55 {\r\n        fill: #e4c064;\r\n      }\r\n\r\n      .cls-32 {\r\n        stroke: #e4c064;\r\n      }\r\n\r\n      .cls-32, .cls-33 {\r\n        stroke-width: 5px;\r\n      }\r\n\r\n      .cls-56 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-4);\r\n      }\r\n\r\n      .cls-57 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-2);\r\n      }\r\n\r\n      .cls-58 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-17);\r\n      }\r\n\r\n      .cls-59 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-15);\r\n      }\r\n\r\n      .cls-60 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-40);\r\n      }\r\n\r\n      .cls-61 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-74);\r\n      }\r\n\r\n      .cls-62 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-60);\r\n      }\r\n\r\n      .cls-63 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-53);\r\n      }\r\n\r\n      .cls-64 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-80);\r\n      }\r\n\r\n      .cls-65 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-86);\r\n      }\r\n\r\n      .cls-66 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-21);\r\n      }\r\n\r\n      .cls-67 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-25);\r\n      }\r\n\r\n      .cls-68 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-35);\r\n      }\r\n\r\n      .cls-69 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-48);\r\n      }\r\n\r\n      .cls-70 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-85);\r\n      }\r\n\r\n      .cls-71 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-71);\r\n      }\r\n\r\n      .cls-72 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-62);\r\n      }\r\n\r\n      .cls-73 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-75);\r\n      }\r\n\r\n      .cls-74 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-79);\r\n      }\r\n\r\n      .cls-75 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-39);\r\n      }\r\n\r\n      .cls-76 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-8);\r\n      }\r\n\r\n      .cls-77 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-54);\r\n      }\r\n\r\n      .cls-78 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-38);\r\n      }\r\n\r\n      .cls-79 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-2);\r\n      }\r\n\r\n      .cls-80 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-51);\r\n      }\r\n\r\n      .cls-81 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-12);\r\n      }\r\n\r\n      .cls-82 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-49);\r\n      }\r\n\r\n      .cls-83 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-19);\r\n      }\r\n\r\n      .cls-84 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-90);\r\n      }\r\n\r\n      .cls-85 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-17);\r\n      }\r\n\r\n      .cls-86 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_103);\r\n      }\r\n\r\n      .cls-87 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-6);\r\n      }\r\n\r\n      .cls-88 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-65);\r\n      }\r\n\r\n      .cls-89 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-50);\r\n      }\r\n\r\n      .cls-90 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130);\r\n      }\r\n\r\n      .cls-91 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-47);\r\n      }\r\n\r\n      .cls-92 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-26);\r\n      }\r\n\r\n      .cls-93 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-87);\r\n      }\r\n\r\n      .cls-94 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-11);\r\n      }\r\n\r\n      .cls-95 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-12);\r\n      }\r\n\r\n      .cls-96 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-68);\r\n      }\r\n\r\n      .cls-97 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-77);\r\n      }\r\n\r\n      .cls-98 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-10);\r\n      }\r\n\r\n      .cls-99 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-41);\r\n      }\r\n\r\n      .cls-100 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-72);\r\n      }\r\n\r\n      .cls-101 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-55);\r\n      }\r\n\r\n      .cls-102 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-57);\r\n      }\r\n\r\n      .cls-34 {\r\n        fill: #e2be63;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-103 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-36);\r\n      }\r\n\r\n      .cls-104 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-73);\r\n      }\r\n\r\n      .cls-105 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-34);\r\n      }\r\n\r\n      .cls-106 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-32);\r\n      }\r\n\r\n      .cls-107 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-33);\r\n      }\r\n\r\n      .cls-108 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-64);\r\n      }\r\n\r\n      .cls-109 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-27);\r\n      }\r\n\r\n      .cls-110 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-6);\r\n      }\r\n\r\n      .cls-111 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-9);\r\n      }\r\n\r\n      .cls-112 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-81);\r\n      }\r\n\r\n      .cls-113 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-29);\r\n      }\r\n\r\n      .cls-114 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-22);\r\n      }\r\n\r\n      .cls-115 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-43);\r\n      }\r\n\r\n      .cls-116 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-9);\r\n      }\r\n\r\n      .cls-117 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-63);\r\n      }\r\n\r\n      .cls-118 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-66);\r\n      }\r\n\r\n      .cls-119 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-30);\r\n      }\r\n\r\n      .cls-120 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-78);\r\n      }\r\n\r\n      .cls-121 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-37);\r\n      }\r\n\r\n      .cls-122 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-52);\r\n      }\r\n\r\n      .cls-123 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-7);\r\n      }\r\n\r\n      .cls-124 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-13);\r\n      }\r\n\r\n      .cls-125 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-83);\r\n      }\r\n\r\n      .cls-126 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_100-23);\r\n      }\r\n\r\n      .cls-127 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_130-18);\r\n      }\r\n\r\n      .cls-128 {\r\n        fill: #570601;\r\n      }\r\n\r\n      .cls-129 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_101);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442",
    cx: 497.46,
    cy: 1002.99,
    fx: 497.46,
    fy: 1002.99,
    r: 117.33,
    gradientTransform: "translate(-295.84 -817.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#de1c14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800501"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 449.34,
    cy: 1180.13,
    fx: 449.34,
    fy: 1180.13,
    r: 62.26,
    gradientTransform: "translate(-295.84 -817.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#d92b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-2",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 437.42,
    cy: 573.48,
    fx: 437.42,
    fy: 573.48,
    r: 62.27,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-3",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 439.3,
    cy: 585.7,
    fx: 439.3,
    fy: 585.7,
    r: 68.26,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-4",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 457.79,
    cy: 579.12,
    fx: 457.79,
    fy: 579.12,
    r: 57.49,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-5",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 437.13,
    cy: 584.12,
    fx: 437.13,
    fy: 584.12,
    r: 68.27,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-6",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 487.14,
    cy: 568.69,
    fx: 487.14,
    fy: 568.69,
    r: 44.1,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-7",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 482.37,
    cy: 570.39,
    fx: 482.37,
    fy: 570.39,
    r: 45.83,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-8",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 437.67,
    cy: 564.51,
    fx: 437.67,
    fy: 564.51,
    r: 57.49,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-9",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 477.18,
    cy: 572.23,
    fx: 477.18,
    fy: 572.23,
    r: 47.93,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-10",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 465.07,
    cy: 576.54,
    fx: 465.07,
    fy: 576.54,
    r: 53.64,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-11",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 471.46,
    cy: 574.26,
    fx: 471.46,
    fy: 574.26,
    r: 50.5,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-12",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 436.57,
    cy: 524.38,
    fx: 436.57,
    fy: 524.38,
    r: 43.11,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-13",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 491.58,
    cy: 567.11,
    fx: 491.58,
    fy: 567.11,
    r: 42.7,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-14",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 433.69,
    cy: 520.78,
    fx: 433.69,
    fy: 520.78,
    r: 44.43,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-15",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 438.66,
    cy: 528.66,
    fx: 438.66,
    fy: 528.66,
    r: 42.7,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-16",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 427.25,
    cy: 512.79,
    fx: 427.25,
    fy: 512.79,
    r: 48.06,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-17",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 430.61,
    cy: 516.94,
    fx: 430.61,
    fy: 516.94,
    r: 46.06,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-18",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 438.07,
    cy: 550,
    fx: 438.07,
    fy: 550,
    r: 50.5,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-19",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 438.24,
    cy: 543.94,
    fx: 438.24,
    fy: 543.94,
    r: 47.93,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-20",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 438.53,
    cy: 533.37,
    fx: 438.53,
    fy: 533.37,
    r: 44.1,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-21",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 437.88,
    cy: 556.79,
    fx: 437.88,
    fy: 556.79,
    r: 53.64,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-22",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 438.39,
    cy: 538.43,
    fx: 438.39,
    fy: 538.43,
    r: 45.83,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-23",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 551.84,
    cy: 550,
    fx: 551.84,
    fy: 550,
    r: 50.5,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-24",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 551.53,
    cy: 538.43,
    fx: 551.53,
    fy: 538.43,
    r: 45.82,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-25",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 551.68,
    cy: 543.93,
    fx: 551.68,
    fy: 543.93,
    r: 47.93,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-26",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 551.39,
    cy: 533.37,
    fx: 551.39,
    fy: 533.37,
    r: 44.1,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-27",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 552.03,
    cy: 556.78,
    fx: 552.03,
    fy: 556.78,
    r: 53.64,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-28",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 423.55,
    cy: 506.77,
    fx: 423.55,
    fy: 506.77,
    r: 50.53,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-29",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 556.22,
    cy: 520.78,
    fx: 556.22,
    fy: 520.78,
    r: 44.43,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-30",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 562.66,
    cy: 512.79,
    fx: 562.66,
    fy: 512.79,
    r: 48.06,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-31",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 559.31,
    cy: 516.93,
    fx: 559.31,
    fy: 516.93,
    r: 46.06,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-32",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 553.34,
    cy: 524.38,
    fx: 553.34,
    fy: 524.38,
    r: 43.11,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-33",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 551.26,
    cy: 528.66,
    fx: 551.26,
    fy: 528.66,
    r: 42.7,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-34",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 552.24,
    cy: 564.51,
    fx: 552.24,
    fy: 564.51,
    r: 57.49,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-35",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 512.73,
    cy: 572.23,
    fx: 512.73,
    fy: 572.23,
    r: 47.93,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-36",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 518.45,
    cy: 574.26,
    fx: 518.45,
    fy: 574.26,
    r: 50.5,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-37",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 498.33,
    cy: 567.11,
    fx: 498.33,
    fy: 567.11,
    r: 42.7,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-38",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 507.55,
    cy: 570.39,
    fx: 507.55,
    fy: 570.39,
    r: 45.83,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-39",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 502.78,
    cy: 568.69,
    fx: 502.78,
    fy: 568.69,
    r: 44.1,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-40",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 552.49,
    cy: 573.47,
    fx: 552.49,
    fy: 573.47,
    r: 62.26,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-41",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 524.84,
    cy: 576.54,
    fx: 524.84,
    fy: 576.54,
    r: 53.64,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-42",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 552.78,
    cy: 584.12,
    fx: 552.78,
    fy: 584.12,
    r: 68.26,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-43",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 550.61,
    cy: 585.7,
    fx: 550.61,
    fy: 585.7,
    r: 68.27,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-44",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 540.58,
    cy: 582.13,
    fx: 540.58,
    fy: 582.13,
    r: 62.26,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-45",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 532.12,
    cy: 579.13,
    fx: 532.12,
    fy: 579.13,
    r: 57.49,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-46",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 414.7,
    cy: 493.81,
    fx: 414.7,
    fy: 493.81,
    r: 57.49,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-47",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 533.13,
    cy: 459.25,
    fx: 533.13,
    fy: 459.25,
    r: 43.12,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-48",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 526.62,
    cy: 452.16,
    fx: 526.62,
    fy: 452.16,
    r: 44.66,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-49",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 529.2,
    cy: 456.05,
    fx: 529.2,
    fy: 456.05,
    r: 43.29,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-50",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 537.65,
    cy: 460.54,
    fx: 537.65,
    fy: 460.54,
    r: 44.52,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-51",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 542.51,
    cy: 461.91,
    fx: 542.51,
    fy: 461.91,
    r: 46.25,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-52",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 514.12,
    cy: 432.84,
    fx: 514.12,
    fy: 432.84,
    r: 54.03,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-53",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 547.79,
    cy: 463.39,
    fx: 547.79,
    fy: 463.39,
    r: 48.36,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-54",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 510.09,
    cy: 426.47,
    fx: 510.09,
    fy: 426.47,
    r: 57.81,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-55",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 520.93,
    cy: 443.44,
    fx: 520.93,
    fy: 443.44,
    r: 48.43,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-56",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 505.47,
    cy: 419.07,
    fx: 505.47,
    fy: 419.07,
    r: 62.49,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-57",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 517.7,
    cy: 438.44,
    fx: 517.7,
    fy: 438.44,
    r: 50.95,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-58",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 523.88,
    cy: 447.98,
    fx: 523.88,
    fy: 447.98,
    r: 46.36,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-59",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 575.21,
    cy: 493.81,
    fx: 575.21,
    fy: 493.81,
    r: 57.49,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-60",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 587.18,
    cy: 478.26,
    fx: 587.18,
    fy: 478.26,
    r: 68.26,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-61",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 580.68,
    cy: 486.7,
    fx: 580.68,
    fy: 486.7,
    r: 62.26,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-62",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 553.61,
    cy: 465,
    fx: 553.61,
    fy: 465,
    r: 50.93,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-63",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 570.5,
    cy: 499.93,
    fx: 570.5,
    fy: 499.93,
    r: 53.64,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-64",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 419.41,
    cy: 499.93,
    fx: 419.41,
    fy: 499.93,
    r: 53.64,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-65",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 567.53,
    cy: 468.81,
    fx: 567.53,
    fy: 468.81,
    r: 57.93,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-66",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 560.12,
    cy: 466.79,
    fx: 560.12,
    fy: 466.79,
    r: 54.07,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-67",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 586.35,
    cy: 473.83,
    fx: 586.35,
    fy: 473.83,
    r: 68.7,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-68",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 576.13,
    cy: 471.12,
    fx: 576.13,
    fy: 471.12,
    r: 62.7,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-69",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 566.36,
    cy: 506.77,
    fx: 566.36,
    fy: 506.77,
    r: 50.53,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-70",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 452.26,
    cy: 460.54,
    fx: 452.26,
    fy: 460.54,
    r: 44.52,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-71",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 429.79,
    cy: 466.79,
    fx: 429.79,
    fy: 466.79,
    r: 54.07,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-72",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 447.4,
    cy: 461.91,
    fx: 447.4,
    fy: 461.91,
    r: 46.25,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-73",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 422.38,
    cy: 468.81,
    fx: 422.38,
    fy: 468.81,
    r: 57.93,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-74",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 442.12,
    cy: 463.39,
    fx: 442.12,
    fy: 463.39,
    r: 48.36,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-75",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 436.31,
    cy: 465,
    fx: 436.31,
    fy: 465,
    r: 50.93,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-76",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 409.23,
    cy: 486.7,
    fx: 409.23,
    fy: 486.7,
    r: 62.26,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-77",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 402.73,
    cy: 478.26,
    fx: 402.73,
    fy: 478.26,
    r: 68.27,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-78",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 403.56,
    cy: 473.83,
    fx: 403.56,
    fy: 473.83,
    r: 68.7,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-79",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 413.78,
    cy: 471.12,
    fx: 413.78,
    fy: 471.12,
    r: 62.7,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-80",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 463.29,
    cy: 452.16,
    fx: 463.29,
    fy: 452.16,
    r: 44.67,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-81",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 475.79,
    cy: 432.84,
    fx: 475.79,
    fy: 432.84,
    r: 54.03,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-82",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 479.82,
    cy: 426.47,
    fx: 479.82,
    fy: 426.47,
    r: 57.81,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-83",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 472.21,
    cy: 438.44,
    fx: 472.21,
    fy: 438.44,
    r: 50.95,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-84",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 489.86,
    cy: 410.28,
    fx: 489.86,
    fy: 410.28,
    r: 68.35,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-85",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 484.45,
    cy: 419.07,
    fx: 484.45,
    fy: 419.07,
    r: 62.49,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-86",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 466.03,
    cy: 447.98,
    fx: 466.03,
    fy: 447.98,
    r: 46.36,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-87",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 468.98,
    cy: 443.44,
    fx: 468.98,
    fy: 443.44,
    r: 48.43,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-88",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 500.05,
    cy: 410.28,
    fx: 500.05,
    fy: 410.28,
    r: 68.35,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-89",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 460.72,
    cy: 456.05,
    fx: 460.72,
    fy: 456.05,
    r: 43.3,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100-90",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 100",
    cx: 456.79,
    cy: 459.25,
    fx: 456.79,
    fy: 459.25,
    r: 43.12,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_100"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_101",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 101",
    cx: 275.36,
    cy: 234.59,
    fx: 275.36,
    fy: 234.59,
    r: 100.3,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ded6c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#f9f0e1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_103",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 103",
    cx: 501.74,
    cy: 1201.13,
    fx: 501.74,
    fy: 1201.13,
    r: 121.02,
    gradientTransform: "translate(-295.84 -817.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#690000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#590000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#4c0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#470000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#740000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cx: 479.61,
    cy: 1173.46,
    fx: 479.61,
    fy: 1173.46,
    r: 103.97,
    gradientTransform: "translate(-295.84 -817.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#d92b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#780000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-2",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cy: 575.46,
    fy: 575.46,
    r: 103.95,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-3",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cy: 575.46,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-4",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cy: 575.46,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-5",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cy: 575.46,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-6",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cy: 575.46,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-7",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cy: 575.46,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-8",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cx: 479.61,
    cy: 575.46,
    fx: 479.61,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-9",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cy: 575.46,
    fy: 575.46,
    r: 103.96,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-10",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cx: 479.61,
    cy: 575.46,
    fx: 479.61,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-11",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cy: 575.46,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-12",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cx: 479.61,
    cy: 575.46,
    fx: 479.61,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-13",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cy: 575.46,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-14",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cx: 479.61,
    cy: 575.46,
    fx: 479.61,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-15",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cy: 575.46,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-16",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cx: 479.61,
    cy: 575.46,
    fx: 479.61,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-17",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cx: 479.61,
    cy: 575.46,
    fx: 479.61,
    fy: 575.46,
    r: 103.92,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-18",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cx: 479.61,
    cy: 575.46,
    fx: 479.61,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-19",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cy: 575.46,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-20",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cx: 479.61,
    cy: 575.46,
    fx: 479.61,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-21",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cx: 479.61,
    cy: 575.46,
    fx: 479.61,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-22",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cx: 479.61,
    cy: 575.46,
    fx: 479.61,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-23",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cy: 575.46,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-24",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cy: 575.46,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-25",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cx: 479.61,
    cy: 575.46,
    fx: 479.61,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-26",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cx: 479.61,
    cy: 575.46,
    fx: 479.61,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130-27",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 130",
    cy: 575.46,
    fy: 575.46,
    r: 103.97,
    gradientTransform: "translate(0 470.18) scale(1 -1)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_130"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m161.8,24.33c-17.6,33.3-36.94,49.02-56.24,64.8-12.81,8.38-24.43,19.26-33.78,31.67-1.3,1.54-2.6,3.13-3.9,4.78-3.52,4.5-6.25,9.57-8.36,14.95-8.17,16.41-7.55,34.06-7.33,51.98.22,18.13,10.15,29.1,10.15,29.1l273.82-1.98,6.25-13.05c10.6-47.3-12.03-58.48-10.6-82.07,1.63-26.93-.34-30.19-.34-30.19-27.52,14.41-37.44,44.85-37.44,44.85C308.17,62.25,279.63,0,279.63,0c-23.53,18.29-49.7,27.93-75.08,42.56-12.57,7.25-33.56,17.05-42.54,28.93,0,0,11.19-14.82-.21-47.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m67.93,225.81l258.19-5.5,6.55-18.6c4.43-11.39,3.75-24.75,2.08-36.64-1.77-12.61-7.99-18.06-7.47-34.48-.4,8.94-27.66,20.5-22.74,30.35,0,0-4.93-9.85,10.74-27.86,8.39-9.64,9.85-25.01,9.85-25.01-9.64,3.98-14.57,15.53-18.36,24.4-3.16,7.39-7.19,14.15-12.74,20.02-2.62,2.77-5.44,5.33-8.33,7.81-2.78,2.39-5.93,4.12-8.42,6.9,22.83-78.69,3.67-132.31,3.67-132.31-8.36,27.93-41.79,39.14-41.79,39.14,43.63-33.03,37.1-60.14,37.1-60.14-12.44,32.21-38.12,41.59-38.12,41.59,15.7-11.01,18.76-29.97,18.76-29.97,0,0-15.49,10.4-28.74,15.49-13.25,5.1-33.23,14.48-57.29,34.66s-39.75,61.16-39.75,61.16c5.3-23.65,13.86-42.4,13.86-42.4-9.99,9.99-31.4,22.22-31.4,22.22,57.08-45.05,43.42-75.63,43.42-75.63-3.22,16.02-1.93,16.22-56.83,61.25-54.9,45.03-36.43,102.98-36.43,102.98l4.18,20.59Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "199.12 405.4 83.33 446.58 86.71 323.74 11.78 226.34 129.65 191.6 199.12 90.23 268.58 191.6 386.45 226.34 311.52 323.74 314.89 446.58 199.12 405.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m199.12,90.23l69.46,101.36,117.87,34.75-74.94,97.39,3.38,122.84-115.78-41.17-115.78,41.17,3.38-122.84L11.78,226.35l117.87-34.75,69.47-101.37m0-12.38l-5.77,8.43-68.06,99.31L9.8,219.63l-9.8,2.89,6.23,8.1,73.42,95.42-3.31,120.35-.28,10.21,9.62-3.42,113.44-40.34,113.43,40.34,9.62,3.42-.28-10.21-3.31-120.35,73.42-95.42,6.23-8.1-9.8-2.89-115.48-34.04-68.06-99.31-5.77-8.43h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "145.12 376.37 107.88 437.85 118.37 434.12 148.91 378.55 199.12 287.21 145.12 376.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "127.76 363.19 84.36 409.41 84.05 420.54 131.02 366.12 199.12 287.21 127.76 363.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "139.03 372.38 87.81 444.98 100.32 440.54 142.66 374.83 199.12 287.21 139.03 372.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "151.47 379.91 124.78 431.84 133.78 428.64 155.4 381.83 199.12 287.21 151.47 379.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "133.24 367.98 83.83 428.55 83.46 441.83 136.69 370.68 199.12 287.21 133.24 367.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "186.05 390.62 183.48 410.96 188.89 409.04 190.4 391.08 199.12 287.21 186.05 390.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "178.87 389.46 173.93 414.36 179.76 412.29 183.18 390.22 199.12 287.21 178.87 389.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "122.64 358.03 84.81 393.05 84.54 402.61 125.68 361.18 199.12 287.21 122.64 358.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "171.78 387.8 163.56 418.05 169.92 415.79 176.03 388.86 199.12 287.21 171.78 387.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "158.05 383.01 139.34 426.66 147.22 423.86 162.11 384.65 199.12 287.21 158.05 383.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "164.83 385.64 152.13 422.11 159.15 419.61 169 387 199.12 287.21 164.83 385.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "82.35 318.06 85.65 322.35 99.55 318.04 199.12 287.21 98.35 313.83 82.35 318.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "193.29 391.28 192.37 407.8 197.47 405.99 197.67 391.43 199.12 287.21 193.29 391.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "76.59 310.58 80.1 315.14 97.64 311.02 199.12 287.21 96.73 306.74 76.59 310.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "100.45 320.8 86.67 325.49 86.52 330.9 101.95 324.91 199.12 287.21 100.45 320.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "63.7 293.83 67.81 299.17 95.32 296.67 199.12 287.21 95.01 292.3 63.7 293.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "70.42 302.55 74.19 307.46 96.23 303.89 199.12 287.21 95.62 299.55 70.42 302.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "113.53 346.7 85.55 366.14 85.34 373.59 116.1 350.24 199.12 287.21 113.53 346.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "109.59 340.58 85.86 354.72 85.68 361.46 111.91 344.29 199.12 287.21 109.59 340.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "103.03 327.6 86.42 334.58 86.26 340.33 104.81 331.6 199.12 287.21 103.03 327.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "117.88 352.52 85.2 378.8 84.97 387.16 120.7 355.87 199.12 287.21 117.88 352.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "106.08 334.21 86.15 344.27 85.98 350.46 108.14 338.07 199.12 287.21 106.08 334.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "282.13 350.24 312.89 373.58 312.68 366.14 284.71 346.7 199.12 287.21 282.13 350.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "290.1 338.07 312.25 350.46 312.08 344.27 292.15 334.2 199.12 287.21 290.1 338.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "286.33 344.29 312.56 361.46 312.37 354.72 288.65 340.58 199.12 287.21 286.33 344.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "293.42 331.6 311.97 340.33 311.82 334.58 295.2 327.6 199.12 287.21 293.42 331.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "277.54 355.87 313.26 387.15 313.03 378.79 280.35 352.52 199.12 287.21 277.54 355.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "56.31 284.21 60.85 290.12 94.91 289.41 199.12 287.21 94.91 285.03 56.31 284.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "300.59 311.02 318.14 315.14 321.64 310.58 301.5 306.74 199.12 287.21 300.59 311.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "302.92 296.67 330.42 299.17 334.53 293.83 303.22 292.3 199.12 287.21 302.92 296.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "302 303.89 324.04 307.46 327.82 302.55 302.61 299.55 199.12 287.21 302 303.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "298.68 318.04 312.59 322.35 315.89 318.06 299.89 313.83 199.12 287.21 298.68 318.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "296.29 324.91 311.72 330.9 311.57 325.49 297.79 320.8 199.12 287.21 296.29 324.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "272.56 361.18 313.69 402.6 313.42 393.05 275.6 358.03 199.12 287.21 272.56 361.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "222.2 388.86 228.32 415.79 234.67 418.05 226.45 387.79 199.12 287.21 222.2 388.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "229.24 387 239.08 419.62 246.1 422.11 233.4 385.64 199.12 287.21 229.24 387"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "200.57 391.43 200.77 405.99 205.87 407.8 204.94 391.28 199.12 287.21 200.57 391.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "215.06 390.22 218.47 412.29 224.3 414.36 219.37 389.46 199.12 287.21 215.06 390.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "207.83 391.08 209.34 409.04 214.76 410.96 212.19 390.62 199.12 287.21 207.83 391.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "267.22 366.12 314.18 420.53 313.87 409.4 270.47 363.19 199.12 287.21 267.22 366.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "236.12 384.65 251.01 423.86 258.89 426.66 240.18 383.01 199.12 287.21 236.12 384.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "261.55 370.68 314.76 441.83 314.4 428.55 265 367.98 199.12 287.21 261.55 370.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "255.57 374.83 297.91 440.54 310.43 444.99 259.2 372.38 199.12 287.21 255.57 374.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "249.32 378.55 279.87 434.12 290.35 437.85 253.12 376.36 199.12 287.21 249.32 378.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "242.83 381.83 264.45 428.64 273.45 431.84 246.76 379.91 199.12 287.21 242.83 381.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "38.6 261.21 44.43 268.78 95.62 274.88 199.12 287.21 96.23 270.55 38.6 261.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "275.46 193.62 270.26 192.1 261.55 203.75 199.12 287.21 265 206.45 275.46 193.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "262.45 182.65 259.2 177.91 249.32 195.87 199.12 287.21 253.12 198.06 262.45 182.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "267.59 190.16 264.53 185.69 255.57 199.6 199.12 287.21 259.2 202.05 267.59 190.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "284.51 196.29 278.99 194.67 267.22 208.31 199.12 287.21 270.47 211.24 284.51 196.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "294.22 199.16 288.29 197.41 272.56 213.25 199.12 287.21 275.6 216.4 294.22 199.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "237.45 146.17 232.72 139.27 222.2 185.57 199.12 287.21 226.45 186.63 237.45 146.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "304.78 202.27 298.31 200.36 277.54 218.56 199.12 287.21 280.35 221.91 304.78 202.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "229.39 134.4 223.98 126.52 215.06 184.21 199.12 287.21 219.37 184.97 229.39 134.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "251.06 166.04 247.25 160.48 236.12 189.78 199.12 287.21 240.18 191.42 251.06 166.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "220.14 120.91 213.84 111.73 207.83 183.35 199.12 287.21 212.19 183.81 220.14 120.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "244.61 156.62 240.39 150.47 229.24 187.43 199.12 287.21 233.4 188.79 244.61 156.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "256.97 174.66 253.47 169.56 242.83 192.6 199.12 287.21 246.76 194.52 256.97 174.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "302.61 274.88 353.8 268.78 359.63 261.21 302 270.54 199.12 287.21 302.61 274.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "299.89 260.6 375.46 240.64 383.56 230.11 298.68 256.39 199.12 287.21 299.89 260.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "301.5 267.69 363.78 255.81 370.57 246.99 300.59 263.41 199.12 287.21 301.5 267.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "316.42 205.7 309.27 203.59 282.13 224.19 199.12 287.21 284.71 227.74 316.42 205.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "303.22 282.13 345.1 280.08 350.21 273.46 302.92 277.76 199.12 287.21 303.22 282.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "48.03 273.46 53.13 280.08 95.01 282.13 199.12 287.21 95.32 277.76 48.03 273.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "344.26 213.91 335.1 211.21 290.1 236.36 199.12 287.21 292.15 240.23 344.26 213.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "329.44 209.54 321.42 207.17 286.33 230.14 199.12 287.21 288.65 233.85 329.44 209.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "381.9 225 369.16 221.25 296.29 249.52 199.12 287.21 297.79 253.63 381.9 225"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "361.47 218.98 350.79 215.83 293.42 242.83 199.12 287.21 295.2 246.83 361.47 218.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "303.32 289.4 337.38 290.12 341.93 284.21 303.32 285.03 199.12 287.21 303.32 289.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "119.24 194.67 113.72 196.29 127.76 211.24 199.12 287.21 131.02 208.31 119.24 194.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "76.81 207.17 68.79 209.54 109.59 233.85 199.12 287.21 111.91 230.14 76.81 207.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "109.94 197.41 104.01 199.16 122.64 216.4 199.12 287.21 125.68 213.25 109.94 197.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "63.13 211.21 53.97 213.91 106.08 240.23 199.12 287.21 108.14 236.36 63.13 211.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "99.92 200.36 93.45 202.27 117.88 221.91 199.12 287.21 120.7 218.56 99.92 200.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "88.96 203.59 81.81 205.7 113.53 227.74 199.12 287.21 116.1 224.2 88.96 203.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "27.66 246.99 34.45 255.81 96.73 267.69 199.12 287.21 97.64 263.41 27.66 246.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "14.67 230.11 22.77 240.63 98.35 260.6 199.12 287.21 99.55 256.39 14.67 230.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "29.07 221.25 16.33 225 100.45 253.63 199.12 287.21 101.95 249.52 29.07 221.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "47.44 215.83 36.76 218.98 103.03 246.83 199.12 287.21 104.81 242.83 47.44 215.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "139.03 177.9 135.78 182.65 145.12 198.07 199.12 287.21 148.91 195.88 139.03 177.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "165.51 139.27 160.78 146.16 171.78 186.64 199.12 287.21 176.03 185.58 165.51 139.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "174.25 126.52 168.85 134.4 178.87 184.98 199.12 287.21 183.18 184.21 174.25 126.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "157.84 150.46 153.63 156.61 164.83 188.79 199.12 287.21 169 187.43 157.84 150.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "196.43 94.15 188.92 105.11 193.29 183.15 199.12 287.21 197.67 183 196.43 94.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "184.39 111.72 178.1 120.91 186.05 183.81 199.12 287.21 190.4 183.35 184.39 111.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "144.76 169.55 141.26 174.65 151.47 194.52 199.12 287.21 155.4 192.6 144.76 169.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "150.98 160.47 147.17 166.03 158.05 191.42 199.12 287.21 162.11 189.78 150.98 160.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "209.31 105.11 201.8 94.15 200.57 183 199.12 287.21 204.94 183.15 209.31 105.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "133.7 185.69 130.64 190.15 139.03 202.05 199.12 287.21 142.66 199.6 133.7 185.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "127.97 192.09 122.78 193.62 133.24 206.45 199.12 287.21 136.69 203.75 127.97 192.09"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m178.64,360.91s-3.75-5.62-20.99-5.62c0,0,2.78-32.08-54.69-24.82l7.54-29.14s.42-2.57,4.85-2.57c5.96,0-1.33-7.28-2.3-8.25-.96-.96.88-4.78,6.21-4.78,0,0-10.42-6.99-11.4-11.25-.42-1.81,3.11-4.97,7.11-6.58,4.35-1.75.35-4.13-1.81-6.5,0,0-4.08-4.02.51-8.61,7.92-7.91,15.09-14.47,17.02-17.63s-6.32-11.18-6.32-11.18c-2.11-3.15,3.66-9.64,5.34-11.9,3.73-5.01,5.57-8.74,6.6-15.02.93-5.63,4.62-10,8.47-14.04,22-23.12,50.4-24.92,75.11-19.01,8.47,2.02,17.96,6.59,24.68,11.35,29.85,21.1,53.96,66,29.24,104.8-21.18,33.24-19.57,49-18.48,57.39l.75,2.3-76.04,23.65-1.38-2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m206.4,314.51c-.82,1.5-1.75,2.91-2.98,4.11-2.08,2.03-4.88,3-7.55,3.97-2.33.84-4.69,1.62-7.08,2.3,0,0-11.96,20.93-14.13,24.33-2.17,3.4.72,5.98,6.93,9.24,6.46,3.4,7.09.53,9.14-2.14.85-1.11,3.25.07,4.39-.78,1.53-1.14,2.28-4.12,3.12-5.76,6.07-11.88,11.14-24.59,18.01-36.04,2.45-4.08-1.15-6.05-2.04-5.17-1.35,1.35-3.9.26-5.33,1.14l-2.47,4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m221.07,328.02c-.76.74-.85,1.63-1.36,2.92-2,5-4.27,9.91-6.44,14.85-.57,1.3-1.25,2.63-1.71,3.98,0,0-.54,1.56,1.97.54,2.02-.82,4-1.45,6.17-1.77,1.19-.17,3.49.09,4.5-.69,1.18-.91,2.22-4.24,2.82-5.62,1.85-4.28,3.86-8.9,4.93-13.46.28-1.2,1.17-3.18-.08-4.02-1.16-.78-5.53.3-7.25,1.25-.89.49-3,1.5-3.54,2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "m271.44,221.44c-3.26-7.57-6.77-15.04-11.15-22.04-5.49-8.79-13.36-15.36-22.06-20.81-23.09-14.45-54.45-14.24-77.88-.41-7.04,4.16-15.49,12.49-17.63,21-3.18,12.59-6.8,17.81-10.19,23.51-1.91,3.22,3.53,5.84,3.53,10.6s-12.17,17.4-15.29,20.52c-3.12,3.12-3.63,3.71.34,7.68,3.97,3.97,5.64.17,8.36.17s3.85,3.67,6.69,3.67,4.01-3.87,2.76-5.68c-2.52-3.66,1.7-4.42,3.49-1.28,1.35,2.36-.33,6.32-2.13,8.12-6.81,6.8-17.72,3.5-17.72,3.5-3.57,2.44-6.41,5.61-6.41,5.61,7.08,7.08,29.42,9.07,29.42,9.07-.78-1.55.03-4.57,1.94-4.37,4.49.47,6.49,6.47,7.65,9.57.47,1.26,1.76,5.98.96,7.34-.01.02-.33,3.61-8.77-4.84-8.47-8.47-29.42-5.33-26.54-2.95,5.1,4.21,1.84,13.49-2.47,17.8-2.57,2.57-5.17,14.94-5.17,14.94,3.64,1.27,10.32,2.42,15.61,1.45,2.85-.52,5.67-1.19,8.48-1.9,2-.51,5.18-1.38,6.59.03.96.96.85,1.26,2.31,1.23,1.4-.03,2.78-.48,4.15-.71,3.05-.51,6.1-1.06,9.11-1.76,5.35-1.24,10.19-3.27,15.15-5.56,1.51-.7,4.76-2.48,6.51-1.41,3.48,2.12,9.83,1.66,19.66-8.17,1.54-1.54,3.08-3.31,4.31-5.24,1.6-2.5,2.71-5.28,2.71-8.23,0-.88-.44-1.67-2.45-3.67-2.01-2,.74-3.81.74-3.47s1.25,3.11,2.42,3.11,4.8-3.2,5.56-1.94c.26.44-1.94,1.43.05,2.75,1.99,1.33,5.38-3.11,5.38-3.11,1.54-1.39,3.08-4.89,5.94-5.25,4.43-.55,7.95-4.41,10.86-7.5,3.33-3.55,6.1-7.61,8.23-11.99,2.41-4.95.07-12.32-5.27-16.57-6.01-4.78-12.63-4.82-18.14.39-1.13,1.07-1.99,2.49-2.96,3.7-.85,1.05-1.56,2.09-2.68,2.86-.21.14-.4.23-.57.26-.74.14-5.15-2.12-5.93-2.59-1.31-.77-1.16-2.53-2.38-3.41-.99-.71-2.52-.24-3.61-.99-3.79-2.59.38-4.02.94-5.7.56-1.68-2.14-3.06-2.65-4.38s-2.58-2.24-2.58-2.24c-2.51-1.87-1.46-5.44-1.46-8.19s-.87-3.99-2.11-5.23c-1.24-1.24-.61-2.21-.61-2.21,2.17-.24,5.13,2.02,6.81,5.39,1.68,3.36,3.21.97,4.08-.46.87-1.43.71-3.82.05-6.57-.66-2.75-2.5-7.24-3.06-10.55-.56-3.31,0-4.89,1.12-4.33,1.12.56,2.85,5.14,3.26,6.42.41,1.29,2.04,3.62,5.1,5.35,3.06,1.73,6.42,5.81,7.75,5.15s-.97-2.35-.1-2.35,1.9.6,2.41-.29c.51-.88-1.63-3.43-3.4-4.04-1.77-.61-4.65-4.04-3.13-3.13,1.53.92,5.49,1.19,5.49,1.19,2.96-.54,5.81-1.57,8.19-3.44.54-.42,1.1-1.11,1.72-1.4,1.49-.7,2.68.73,3.75,1.56,1.63,1.26,3.34,2.41,5.35,2.96,2.24.61,11.01-1.68,11.47.46.74,3.48,5.15,9.56,5.15,9.56,8.83,10.74,17.12,8.53,17.12,8.53-.81-2.08-1.48-3.58-2.16-5.16Zm-141.18,80.67c-.75-2.3-1.72-5.83-1.04-8.27.17-.61.51-1.21,1.24-1.59,2.36-1.23,9.38,2.34,8.95,5.08-.53,3.34-6.56,4.05-9.15,4.78Zm48.1-69.12c-1.66,0-14.31-8.38-17.69-5.9-4.2,3.08-9.68,4.23-9.68,5.44,0,1.97,2.58,2.66,4.03,3.28,0,0,2.51.68,4.93,1.22,2.41.54,3.43,2.27,3.43,2.27,1.85,2.22,3.25,2.55,6.73,2.55,2.95,0,4.8-.68,7.51-1.36.07.97-.07,2.43-.21,3.41-.64,4.23-8.34,1.98-11.06,2.94-2.18.77-4.1,1.76-6.09,2.89-3.13,1.77-6.82.59-6.12-.41.87-1.22,2.24-4.01,4.15-4.48,1.21-.3,2.72-.95,2.72-1.56s-2.92-1.43-4.21-.88c-1.29.54-3.26,1.63-2.72,2.18.54.54,1.78.42-1.21,2.46-2.99,2.04-4.18-1.16-4.18-1.16-.68-2.04-6.58-3.4-6.58-3.4-2.84-1.7-2.67-1.76-.68-3.74.79-.79,2.54-2.69,1.97-3.86-.54-1.11-2.87-1.15-2.88-2.83,0-1.51.24-4.39,1.41-5.48.86-.8,2.91-.89,4.02-1.13,2.97-.66,6.07-1.43,8.98-2.33,1.45-.44,7.69-3.29,9.07-1.91,1.44,1.44,18.68,10.28,18.68,10.28,0,0-2.65,1.51-4.31,1.51Zm34.25,38.8c.61-.98,5.1-3.3,5.44-5.16.34-1.87-1.53-2.27-1.53-2.82s.49-1.61,1.02-1.09c.53.53,1.63.82,1.63.82,2.31-.95,2.07-4.32,2.07-4.32,0-2.31-3.13-4.28-1.56-5.84,1.56-1.56,9.92-6.46,11.35-5.78,1.43.68,5.84,5.03,5.84,6.05s.48,5.23-.61,8.56-1.77.48-1.77.48h0v-.27c0-1.98-.41-7.01-2.98-7.55-1.53-.32-5.2,2.12-5.58,3.68-.61,2.52,1.65,4.14,1.29,9.58-.41,6.11-4.55,5.98-7.95,5.98s-3.6,3.6-5.71,3.6-3.67-2.38-3.67-2.38l3.7-2.55c-1.6,0-.99-.99-.99-.99Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "336.16 372.63 75.02 464.36 55.04 408.71 356.75 302.71 336.16 372.63"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "118.71 434 149.25 378.44 151.17 374.94 144.92 377.13 108.22 437.73 118.71 434"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "100.66 440.41 140.42 378.71 132.97 381.33 88.15 444.86 100.66 440.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "125.12 431.72 134.12 428.52 155.74 381.71 160.37 371.71 155 373.59 151.81 379.8 125.12 431.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "83.8 441.71 127.54 383.24 118.42 386.44 84.17 428.44 83.8 441.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "183.81 410.85 189.23 408.92 190.74 390.96 193.33 360.12 190.08 361.27 186.39 390.5 183.81 410.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "174.27 414.24 180.1 412.17 183.52 390.1 187.86 362.05 184.37 363.27 179.2 389.34 174.27 414.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "163.9 417.93 170.25 415.67 176.37 388.74 181.96 364.12 178.16 365.46 172.12 387.68 163.9 417.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "139.68 426.54 147.56 423.74 162.45 384.54 168.39 368.89 163.69 370.54 158.39 382.89 139.68 426.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "152.47 421.99 159.49 419.5 169.34 386.88 175.52 366.38 171.33 367.86 165.17 385.53 152.47 421.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "192.71 407.68 197.8 405.87 198.01 391.31 198.47 358.32 195.41 359.39 193.63 391.16 192.71 407.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "313.23 373.46 313.02 366.02 285.05 346.58 267.2 334.17 263.28 335.55 282.47 350.12 313.23 373.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "312.59 350.33 312.42 344.15 292.49 334.08 282.22 328.89 277.31 330.62 290.44 337.95 312.59 350.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "312.89 361.34 312.71 354.6 288.99 340.46 274.27 331.69 269.92 333.21 286.67 344.17 312.89 361.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "312.31 340.21 312.16 334.46 295.54 327.48 291.31 325.7 285.68 327.68 293.76 331.48 312.31 340.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "280.69 352.4 260.81 336.42 257.22 337.67 277.87 355.76 308.32 382.41 313.42 380.62 313.37 378.67 280.69 352.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "254.95 338.48 251.63 339.64 272.89 361.06 297.77 386.12 304.03 383.92 275.94 357.91 254.95 338.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "217.04 351.79 214.36 352.74 222.54 388.74 227.55 410.79 232.59 409.01 226.79 387.68 217.04 351.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "221.45 350.24 218.8 351.18 229.58 386.88 235.9 407.85 240.9 406.09 233.74 385.52 221.45 350.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "201.11 405.87 206.2 407.69 205.28 391.16 203.34 356.61 200.44 357.63 200.9 391.32 201.11 405.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "212.58 353.36 209.86 354.32 215.39 390.1 218.81 412.17 221.2 413.02 224.19 411.96 219.71 389.34 212.58 353.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "209.68 408.92 215.1 410.85 212.53 390.5 208.03 354.96 205.23 355.94 208.17 390.96 209.68 408.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "249.51 340.39 246.39 341.48 267.56 366 287.91 389.58 293.77 387.52 270.81 363.07 249.51 340.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "225.86 348.7 223.2 349.63 236.46 384.54 244.21 404.93 249.22 403.17 240.52 382.89 225.86 348.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "244.39 342.18 241.44 343.22 261.89 370.56 278.57 392.86 284.13 390.91 265.34 367.86 244.39 342.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "239.53 343.89 236.69 344.89 255.91 374.71 269.63 396 274.97 394.13 259.54 372.26 239.53 343.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "234.85 345.54 232.11 346.5 249.66 378.44 260.99 399.04 266.16 397.22 253.45 376.25 234.85 345.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "230.31 347.13 227.63 348.08 243.17 381.71 252.54 402 257.6 400.23 247.1 379.8 230.31 347.13"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-33",
    x1: 73.88,
    y1: 453.3,
    x2: 340.01,
    y2: 359.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m89.7,412.85c1.14-.79,3.04-1.75,5.07-2.46,2.89-1.02,4.98-1.04,6.88-.08,1.55.7,2.85,2.15,3.65,4.41.98,2.77.41,5.7-1.56,7.64l.03.08c2.37-.07,5.65,1.31,7.16,5.56.87,2.47.77,4.61.14,6.42-.92,2.38-3.14,4.12-6.79,5.42-1.99.7-3.58,1.07-4.6,1.24l-9.97-28.23Zm7.04,10.73l2.62-.93c3.06-1.08,4.13-3.76,3.15-6.52-1.19-3.36-3.65-3.98-6.57-2.95-1.33.47-2.05.87-2.47,1.16l3.26,9.24Zm4.86,13.76c.61-.07,1.46-.32,2.49-.69,2.99-1.06,5.25-3.44,3.78-7.61-1.38-3.92-4.58-4.61-7.74-3.49l-2.39.85,3.87,10.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m134.41,427.86c-.82,1.06-2.69,2.53-5.42,3.49-6.31,2.23-12.88-1.24-16.21-10.65-3.17-8.99-.57-16.75,6.37-19.21,2.79-.98,4.82-.84,5.77-.6l.37,3.27c-1.34-.29-3.08-.25-4.94.4-5.25,1.85-7.22,7.39-4.55,14.93,2.48,7.02,7.23,10.43,12.68,8.5,1.76-.62,3.39-1.73,4.3-2.86l1.63,2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m146.86,409.38l-8.7,3.07,3.65,10.35,9.7-3.43,1.1,3.11-12.59,4.45-10.14-28.7,12.09-4.27,1.1,3.11-9.2,3.25,3.2,9.07,8.7-3.07,1.08,3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m159.78,387.66l1.1,3.11-9,3.18,9.04,25.59-2.89,1.02-10.14-28.7,11.89-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m165.05,385.8l12.52-4.42,9.07,25.68,1.99-.61,2.29,6.92-2.26.8-1.65-3.84-14.12,4.99,1.25,3.98-2.26.8-2.68-6.77,1.66-.68-5.82-26.83Zm8.79,25.73l9.9-3.5-7.97-22.57-6.94,2.45,5.02,23.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m195.53,397.17l.86,9.85-2.99,1.06-2.53-31.39,9.2-3.27,12.07,28.04-3.09,1.09-3.46-9-10.05,3.62Zm-.43-3.11l9.39-3.36-5.06-13.38-5.77,2.06,1.45,14.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m227.54,363.73l1.1,3.11-9,3.18,9.04,25.6-2.89,1.02-10.14-28.7,11.89-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m254.62,369.97c3.49,9.88.66,16.77-5.06,18.79-5.91,2.09-12.14-2.32-15.21-11.01-3.22-9.11-.91-16.64,5.07-18.75,6.11-2.16,12.19,2.45,15.2,10.97Zm-17.21,6.61c2.17,6.13,6.7,10.71,11.25,9.1,4.58-1.62,5.27-7.94,2.96-14.46-2.02-5.71-6.45-10.85-11.26-9.15-4.78,1.69-5.18,8.2-2.95,14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m260.17,355.75l-6.81,2.4-1.11-3.15,16.57-5.85,1.11,3.15-6.84,2.42,9.02,25.55-2.92,1.03-9.02-25.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m320.78,330l7.42,21.42-2.92,1.03-7.54-21.38,3.04-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m330.11,356.54l.96,2.78-2.92,1.03-1.08-2.74,3.04-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m295.91,355.38c3.49,9.88.66,16.77-5.06,18.79-5.91,2.09-12.14-2.32-15.21-11.01-3.22-9.11-.91-16.64,5.07-18.75,6.11-2.16,12.19,2.45,15.2,10.97Zm-17.21,6.61c2.17,6.13,6.7,10.71,11.25,9.1,4.58-1.62,5.27-7.94,2.96-14.46-2.02-5.71-6.45-10.85-11.27-9.15-4.78,1.69-5.17,8.2-2.95,14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m296.49,339.8c1.14-.79,3.05-1.75,5.07-2.46,2.89-1.02,4.98-1.04,6.88-.08,1.55.7,2.85,2.15,3.65,4.41.98,2.77.41,5.7-1.56,7.64l.03.09c2.37-.07,5.65,1.31,7.16,5.56.87,2.47.77,4.61.14,6.42-.91,2.38-3.14,4.13-6.79,5.42-1.99.7-3.58,1.07-4.6,1.24l-9.97-28.23Zm7.04,10.73l2.62-.93c3.06-1.08,4.13-3.76,3.15-6.52-1.19-3.36-3.65-3.98-6.57-2.95-1.33.47-2.05.87-2.47,1.16l3.27,9.24Zm4.86,13.75c.61-.07,1.45-.32,2.48-.69,2.99-1.06,5.25-3.44,3.77-7.61-1.39-3.92-4.58-4.61-7.73-3.49l-2.39.85,3.87,10.94Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: 58.94,
    y1: 419.58,
    x2: 352.92,
    y2: 315.74
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "336.16 372.63 75.02 464.36 55.04 408.71 356.75 302.71 336.16 372.63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPioneersPin);
export default __webpack_public_path__ + "static/media/Pioneers_pin.058b4d9434ee724bedbac00f1303fac4.svg";
export { ForwardRef as ReactComponent };